import React from 'react'
import PropTypes from 'prop-types'

import IndexList from './IndexList'
import PaginationContainer from './Pagination.container'
import { PaginationWrapper, IconWrapper } from './Pagination.styles'
import { Icon } from '../../shared/tr-icons'

const Pagination = ({ config, criterion, currentIndex, theme }) => {
  if (isNaN(currentIndex)) {
    return (
      <PaginationContainer config={config} criterion={criterion}>
        {pagination => (
          <PaginationPure {...pagination} config={config} criterion={criterion} />
        )}
      </PaginationContainer>
    )
  } else {
    return (
      <PaginationContainer currentIndex={currentIndex} config={config} criterion={criterion}>
        {pagination => (
          <PaginationPure {...pagination} config={config} criterion={criterion} />
        )}
      </PaginationContainer>
    )
  }
}

class PaginationPure extends React.Component {
  componentDidMount() {
    const {
      criterion: { _page },
      setIndex,
      totalPages
    } = this.props

    if (_page > 0 && _page <= totalPages) {
      setIndex(_page - 1)
    }
  }

  render() {
    const {
      config,
      criterion,
      currentIndex,
      nextHandler,
      prevHandler,
      setIndex,
      totalPages
    } = this.props

    return (
      <div style={{ width: '100%' }}>
        <PaginationWrapper role='navigation'>
          <IconWrapper
            onClick={prevHandler}
            disabled={this.props.criterion.basicPaginationEnabled ? currentIndex === 0 ? !this.props.criterion.lessItems : false : currentIndex <= 0}
            data-testid='prev-button'
            className={this.props.criterion.basicPaginationEnabled ? 'basicPaginationPrev' : false}
          >
            <Icon type='arrowLeft' />
            <span className='prev'>{config.previousPageLabel}</span>
          </IconWrapper>
          {!this.props.criterion.basicPaginationEnabled &&
            <ul data-testid='page-list'>
              <IndexList
                totalPages={totalPages}
                criterion={criterion}
                currentIndex={currentIndex}
                setIndex={setIndex}
              />

              <li className='pagination__tally' data-testid='pagination-tally'>
                {' '}
                {currentIndex + 1} / {totalPages}
              </li>
            </ul>
          }
          <IconWrapper
            onClick={nextHandler}
            disabled={this.props.criterion.basicPaginationEnabled ? currentIndex + 1 === totalPages ? !this.props.criterion.moreItems : false : currentIndex >= (totalPages - 1)}
            data-testid='next-button'
            className={this.props.criterion.basicPaginationEnabled ? 'basicPaginationNext' : false}
          >
            <span className='next'>{config.nextPageLabel}</span>
            <Icon type='arrowRight' />
          </IconWrapper>
        </PaginationWrapper>
      </div>
    )
  }
}

Pagination.propTypes = {
  // onUpdate: PropTypes.func.isRequired,
  // totalPages: PropTypes.number.isRequired,
  // getCssClass: PropTypes.func.isRequired,
  config: PropTypes.shape({
    previousPageLabel: PropTypes.string.isRequired,
    nextPageLabel: PropTypes.string.isRequired
  }),
  criterion: PropTypes.shape({
    total: PropTypes.number.isRequired,
    _page: PropTypes.number,
    _perpage: PropTypes.number.isRequired
  })
}

export default Pagination
